/**
 * Lazy-loads predictive-search-searchspring.js when the search modal is opened.
 * Reduces initial page load cost for users who never open search.
 * Listens for dialog:open from dialog.js; when the search modal opens, injects the script once.
 */

const DIALOG_OPEN_EVENT = 'dialog:open';
const SEARCH_MODAL_ID = 'search-modal';
const SCRIPT_URL_ATTR = 'data-ss-predictive-script-url';

let predictiveScriptLoaded = false;

function loadPredictiveScript() {
  if (predictiveScriptLoaded) return;

  const modal = document.getElementById(SEARCH_MODAL_ID);
  if (!modal) return;

  const placeholder = modal.querySelector(`[${SCRIPT_URL_ATTR}]`);
  const url = placeholder?.getAttribute(SCRIPT_URL_ATTR);
  if (!url) return;

  predictiveScriptLoaded = true;

  const script = document.createElement('script');
  script.src = url;
  script.type = 'module';
  script.fetchPriority = 'low';
  document.head.appendChild(script);
}

function handleDialogOpen(event) {
  if (event.target?.id === SEARCH_MODAL_ID) {
    loadPredictiveScript();
  }
}

if (typeof window !== 'undefined' && window.searchspringConfig?.enabled) {
  document.addEventListener(DIALOG_OPEN_EVENT, handleDialogOpen, { capture: true, passive: true });
}
